<template lang="pug">
div
  section.full__video
    .intro__content.intro__content--mobile.enterprise--intro
      h1 Enterprise Plan
      h2 Modern marketers use cinemagraphs to create eye-catching content that drives real business results. Learn how Flixel works with enterprise clients.
      .btn__group.btn__group--splash
        a(href="mailto:support@flixel.com")
          button.btn.btn--purpleLight Contact Us
    .fluid__video.splash
      .intro__content.intro__content--desktop.enterprise--intro
        h1 Enterprise Plan
        h2 Modern marketers use cinemagraphs to create eye-catching content that drives real business results. Learn how Flixel works with enterprise clients.
        .btn__group.btn__group--splash
          a(href="mailto:support@flixel.com")
            button.btn.btn--purpleLight Contact Us
          
      iframe(data-src='https://media.flixel.com/cinemagraph/zgznwtla5esqo0bqxtzd?hd=true' allow='autoplay')
      .credit
        a(target='_blank' href='https://flixel.com/cinepix/') Cinepix

  brands
  
  section.enterprise__section
    .enterprise--product
      .title__container
        h1 What are Cinemagraphs?
        p Cinemagraphs — sometimes known as living photos — blend photography and video together. They are composed like a photo that contain a perfectly looped motion. Cinemagraphs are shared as a short video file, and look great on social media, in e-mails, on digital displays, TV ads, and websites.
    .enterprise__section--container.enterprise__container--row
      .enterprise__section--content
        .enterpriseItem__title
          img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/products/mac/icons/cinemagraph-pro-icon@2x.png 2x, https://cdn.flixel.com/static/static-web/products/mac/icons/cinemagraph-pro-icon.png 1x')
          h2
            | Cinemagraph Pro <br>
            span for macOS
        .productItem__desc
          p Creating professional quality cinemagraphs is fast, fun, and easy with Cinemagraph Pro for macOS. Winner of a 2014 Apple Design Award and the world’s favorite way to create cinemagraphs.
          .btn__group.btn__group--splash
            a(href="mailto:support@flixel.com")
              button.btn.btn--purpleLight Contact Us
        img#designaward(srcset='https://cdn.flixel.com/static/static-web/awards/awardada@2x.png 2x ,https://cdn.flixel.com/static/static-web/awards/awardada.png 1x')
      .enterprise__section--image
        img.lazy.fcpImage(data-srcset='https://cdn.flixel.com/static/static-web/products/mac/cinemagraph-pro@2x.png 2x,https://cdn.flixel.com/static/static-web/products/mac/cinemagraph-pro.png 1x')

  section.enterprise__section
    .enterprise__section--container.product__section--reverse
      .enterprise__section--content
        .enterprise--title
          img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/casestudies/pepsico@2x.png 2x, https://cdn.flixel.com/static/static-web/casestudies/pepsico@1x.png 1x')
          h2 Cinemagraphs at work
        .enterpriseItem__desc
          p PepsiCo is no stranger to generating brand awareness through visual storytelling. To launch their new lemon-lime beverage Mist Twst, they worked with Flixel Studios to test cinemagraph ads against still image ads on Facebook. The thumb-stopping engagement proved that cinemagraphs are the best way to put a twist on your campaign, and drive results.
          a.enterpriseItem__desc--purpleLink(href='http://blog.flixel.com/pepsico-tests-cinemagraphs-in-facebook-ads/') Learn More >
        .enterpriseItem__stats
          .stat__item
            .stat__item--number 
              h2 75%
            .stat__item--desc
              h3 Increase in CTR
          .stat__item
            .stat__item--number 
              h2 51x
            .stat__item--desc 
              h3 Increase in Engagement
      .enterprise__section--cinemagraph
        .fluid__video.rounded__corners
          iframe(data-src='https://media.flixel.com/cinemagraph/48dciji2l85olekpzckh?hd=true' allow='autoplay')

  section.enterprise__section
    .enterprise__section--container
      .enterprise__section--header
        h2 Flixel Enterprise
        p Custom cinemagraph software and services that help companies easily create dynamic video content, increase conversions, and stand out online.
      .enterprise__section--grid
        .enterprise__grid--item
          .enterprise__grid--img.rounded__corners
            img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/products/enterprise/cinemagraphprosquare@2x.png 2x, https://cdn.flixel.com/static/static-web/products/enterprise/cinemagraphprosquare.png 1x')
          .enterprise__grid--title
            h3 Cinemagraph Pro
          .enterprise__grid--desc
            p Cinemagraph Pro for macOS licenses for each of your team members.
        .enterprise__grid--item
          .enterprise__grid--img
            .fluid__video.rounded__corners
              iframe(data-src='https://media.flixel.com/cinemagraph/vs3y71og8bfgwgha9dav?hd=true' allow='autoplay')
          .enterprise__grid--title
            h3 Stills to Motion
          .enterprise__grid--desc
            p Flixel Studios can turn your existing photo assets into mesmerizing cinemagraphs.
        .enterprise__grid--item
          .enterprise__grid--img
            .fluid__video.rounded__corners
              iframe(data-src='https://media.flixel.com/cinemagraph/xwldyfcx0nhborb5jkth?hd=true' allow='autoplay')
          .enterprise__grid--title
            h3 Consultation
          .enterprise__grid--desc
            p Custom cinemagraph campaign consultation with Flixel Studios.
      .enterprise__section--footer
          h3 + Added Support
          p 24 hour reply and direct number call in during weekday hours (9am - 6pm EST).

  section.enterprise__section
    .enterprise__section--callout
      .callout__title
        h1 Tell your brand story with cinemagraphs
      .callout__text
        p Cinemagraphs resonate with audiences in ways that photos no longer can. Use cinemagraphs as a part of your digital marketing campaigns to drive higher CTRs, lower CPC, and increase engagement.
      .btn__group
        a.btn.btn--purpleLight.btn__splash(href="mailto:support@flixel.com") Contact Us
</template>

<script>
import Brands from 'components/Brands.vue';
import productmixin from './productmixin.vue';

export default {
  name: 'Enterprise',
  mixins: [productmixin],
  mounted() {
    window.scrollTo(0, 0);
  },
  components: {
    'Brands': Brands,
  },
};
</script>




// WEBPACK FOOTER //
// src/views/products/enterprise.vue